
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.356 2.222h15.277l-1.044-1.11H3.256l-.9 1.11m17.133.256c.322.378.511.855.511 1.41v13.89A2.222 2.222 0 0117.778 20H2.222A2.222 2.222 0 010 17.778V3.888c0-.555.189-1.032.511-1.41L2.044.61A1.651 1.651 0 013.334 0h13.333c.522 0 .977.233 1.277.611l1.545 1.867M3.333 16.667H10v-3.334H3.333v3.334z"}})])
          )
        }
      }
    